import { DATE_FORMAT } from 'v2/core/date/date';
import { TimeRange } from 'v2/core/entities';
import { DateTimeRange } from '../components/DateRangePicker/types';

export function formatDateTimeRange(
  timeRange: DateTimeRange | TimeRange,
): string {
  if ('last' === timeRange.type) {
    return `For last ${timeRange.value} ${timeRange.unit}${
      (timeRange.value ?? 0) > 1 ? 's' : ''
    }`;
  }

  if ('since' === timeRange.type) {
    return timeRange.startAfter
      ? `Since ${timeRange.startAfter.tz().format(DATE_FORMAT)}`
      : '';
  }

  if (timeRange.startAfter && timeRange.endBefore) {
    return `${timeRange.startAfter
      .tz()
      .format(DATE_FORMAT)} - ${timeRange.endBefore.tz().format(DATE_FORMAT)}`;
  }

  return '';
}
